<template>
  <div class="bd">

    <Homepage />

  </div>
</template>

<script>
import Homepage from './components/homepage.vue'
// import test from './components/test'
export default {
  name: 'App',
  components: {
    Homepage
    // test
  }
}
</script>

<style>
.bd{

 margin-top: 15px;
  overflow: hidden;

}
</style>
